export const reasonsValues = [
  'new_entry',
  'shift_change',
  'change_of_address',
] as const;

export type DocumentRequestReason = (typeof reasonsValues)[number];

export type ReasonOption = { label: string; value: DocumentRequestReason };

export const reasonsMap: Record<DocumentRequestReason, ReasonOption> = {
  new_entry: {
    label: 'Novo ingresso / Desligamento',
    value: 'new_entry',
  } as const,
  shift_change: { label: 'Troca de turno', value: 'shift_change' } as const,
  change_of_address: {
    label: 'Mudança de endereço',
    value: 'change_of_address',
  } as const,
};

export const reasonOptions = [
  reasonsMap.new_entry,
  reasonsMap.shift_change,
  reasonsMap.change_of_address,
];

export type CustomField = {
  name: string;
  label: string;
};

export const reasonsFieldsMap: Record<
  DocumentRequestReason,
  { fields: CustomField[] }
> = {
  new_entry: {
    fields: [{ name: 'new_address', label: 'Endereço completo' }],
  },
  shift_change: {
    fields: [
      { name: 'old_shift', label: 'Turno antigo' },
      { name: 'new_shift', label: 'Novo turno' },
      { name: 'new_address', label: 'Endereço completo' },
    ],
  },
  change_of_address: {
    fields: [
      { name: 'old_address', label: 'Endereço antigo' },
      { name: 'new_address', label: 'Endereço completo' },
    ],
  },
};
